<div class="alert-container" aria-live="polite">
  @for (alert of alertService.alerts(); track alert.id) {
    <div class="alert alert-{{ alert.type }} alert-dismissible fade show" role="alert">
      <span class="material-symbols-outlined alert-container-icon">
        @switch (alert.type) {
          @case ('success') {
            check_circle
          }
          @case ('danger') {
            error
          }
          @case ('warning') {
            warning
          }
          @case ('info') {
            info
          }
        }
      </span>

      {{ alert.message }}

      @if (alert.dismissible) {
        <button
          type="button"
          class="btn-close"
          (click)="alertService.dismiss(alert.id)"
          aria-label="Cerrar"
        ></button>
      }
    </div>
  }
</div>
